import React from "react";
import format from "date-fns/format";
import nb from "date-fns/locale/nb";
import { PhoneNumberFormatters } from "../../../../app/utils";
import "./PortingCardSimplified.less";

const formatterPhone = PhoneNumberFormatters[0].displayFn;

interface PortingCardSimplifiedProps {
    date?: string;
    phoneNumber: string;
}

const PortingCardSimplified: React.FC<PortingCardSimplifiedProps> = ({ phoneNumber, date }) => {
    const newDate = date ? new Date(date) : null;

    return (
        <div className="porting-card-simplified">
            <div className="porting-card-simplified__group">
                <span className="porting-card-simplified__group-heading">Telefonnummer</span>
                <span data-di-mask>{formatterPhone(phoneNumber)}</span>
            </div>
            {newDate && (
                <>
                    <div className="porting-card-simplified__group">
                        <span className="porting-card-simplified__group-heading">Dato</span>
                        <span>{format(newDate, "dd.MM.yyyy", { locale: nb })}</span>
                    </div>
                    <div className="porting-card-simplified__group">
                        <span className="porting-card-simplified__group-heading">Tid</span>
                        <span>kl. {format(newDate, "kk:mm", { locale: nb })}</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default PortingCardSimplified;
